

<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title"><b>{{ this.getFullNameByLanguage(customers_info)}}</b></h3>
        <!-- <h3 class="box-title pull-right">{{ $t(`customer.profile`) }}</h3> -->
        <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onClickOpenCustomer"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-user"></i>
            </span>
            {{ $t(`customer.profile`) }}
          </button>
      </div>

      <div class="box-body">
        <div class="row">
          <div class="col-sm-12">
            <!-- <b>{{this.getFullNameByLanguage(null)}}</b> -->
            <div class="row">
              <div class="col-md-3 col-lg-3">
                <b>{{$t('customer.customer_code')}}:</b>
                {{(customers_info.profile == null) ? "" : customers_info.profile.code}}
                <br />
                <b>{{$t('customer.email')}}:</b>
                {{(customers_info.profile == null) ? "" : customers_info.email}}
              </div>

              <div class="col-md-3 col-lg-3">
                <b>{{$t('customer.phone')}}:</b>
                {{(customers_info.profile == null) ? "" : customers_info.profile.phone}}
                <br />
                <b>{{$t('customer.gender')}}:</b>
                {{ (customers_info.profile == null) ? "" : this.getGenderByLanguage(customers_info)}}
              </div>

              <div class="col-md-3 col-lg-3">
                <b>{{$t('customer.country')}}:</b>
                {{(customers_info.profile == null) ? "" : customers_info.profile.country_name}}
                <br />
                <b>{{$t('customer.privilege')}}:</b>
                {{(customers_info.privilege == null) ? "" : (customers_info.privilege.length > 0 ? customers_info.privilege[0].project_member_role_code : "")}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal -->
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
//import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import constants from "@/lib/constantsData";
import i18n from '../../lang';
import utils from '@/lib/utils';


// Import EventBus.
// import { EventBus } from './event-bus.js';

export default {
  name: "SearchCustomerInfo",
  props: ["item"],
  data() {
    return {
      customers_info: {},
      dateOptions: {
        format: "DD/MM/YYYY"
      },
      customers: [],
      current_debt: 0
    };
  },
  watch: {

  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ]),
  },
  methods: {
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST"
    ]),
    onClickOpenCustomer: function() {
      let routeData = this.$router.resolve({
        name: "CustomerAdd",
        params: {
          id: this.item.id
        }
      });
      window.open(routeData.href, "_blank");
    },
    getFullNameByLanguage(data){
      return utils.getFullName(data.first_name, data.last_name, i18n.locale)
    },
    getGenderByLanguage(data){
      let gender_id = data.profile.gender
      let gender =
          gender_id == 2
            ? this.$t("customer.gender_type[1]")
            : gender_id == 1
            ? this.$t("customer.gender_type[0]")
            : this.$t("customer.gender_type[2]");
      return gender
    },
  },
  mounted() {
    this.customers_info = this.item
  },
  components: {
    //"date-picker": datePicker,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.label-red {
  background-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchCustomerInfo.vue